import {
	EditCustomerContext,
	IEditCustomerContext,
} from 'modules/CustomersAndRestaurants/Customers/EditCustomer/editCustomerState/editCustomerContext';
import React, { useContext, useEffect, useState } from 'react';
import { switchArrayItems } from 'utils/helpers';
import LanguageBarItem from 'components/LanguageBarItem/LanguageBarItem';
import { ICustomerLanguage } from 'types';
import { ILocalizationContext, LocalizationContext } from '../../../../localizationState/localizationContext';
import style from './LanguageBar.module.scss';

interface ILanguageBar {
	items: ICustomerLanguage[];
}

const LanguageBar: React.FC<ILanguageBar> = ({ items }) => {
	const { setLanguage, selectedLanguage } = useContext<ILocalizationContext>(LocalizationContext);
	const { IDSelectedCustomerDefaultLanguage } = useContext<IEditCustomerContext>(EditCustomerContext);
	const [orderedLanguages, setOrderedLanguages] = useState<ICustomerLanguage[]>([]);

	useEffect(() => {
		const indexOfDefaultLanguage = items.findIndex((el) => el.languageId === IDSelectedCustomerDefaultLanguage);
		const orderedByDefaultLanguage = switchArrayItems(items, indexOfDefaultLanguage, 0);
		setOrderedLanguages(orderedByDefaultLanguage);
	}, [items, IDSelectedCustomerDefaultLanguage]);

	useEffect(() => {
		const initialLanguage = orderedLanguages.length
			? { id: orderedLanguages[0].languageId, name: orderedLanguages[0].languageName }
			: null;
		setLanguage(selectedLanguage ? selectedLanguage : initialLanguage);
	}, [selectedLanguage, orderedLanguages]);

	return (
		<>
			{orderedLanguages.length ? (
				<div className={style.container} data-test="LanguageBar">
					{orderedLanguages.map((el) => (
						<LanguageBarItem
							key={el.languageId}
							languageId={el.languageId}
							isActive={selectedLanguage?.id === el.languageId}
							onClick={() => setLanguage({ id: el.languageId, name: el.languageName })}
						/>
					))}
				</div>
			) : null}
		</>
	);
};

export default LanguageBar;
